import './infografica.scss';

/**
 * version    1.0
 * class      <type> (Infografica)
 * classdesc  Component that contains the logic for Infografica
 */
export class Infografica {}
